export const colorsCromatic = (colorMode: boolean) => {
  const green = {
    darker: !colorMode ? "#16514A" : "#16514A",
    dark: !colorMode ? "#119F66" : "#119F66",
    main: !colorMode ? "#1AD879" : "#1AD870",
    light: !colorMode ? "#8CFDB2" : "#8CFDB2",
    lighter: !colorMode ? "#C8FADA" : "#C8FADA",
  };
  const blue = {
    darker: !colorMode ? "#004061" : "#004061",
    dark: !colorMode ? "#006C9C" : "#006C9C",
    main: !colorMode ? "#00B8D9" : "#00B8D9",
    light: !colorMode ? "#57DADA" : "#66CAF5",
    lighter: !colorMode ? "#C6F6FF" : "#C6F6FF",
  };
  const yellow = {
    darker: !colorMode ? "#7A4100" : "#7A4100",
    dark: !colorMode ? "#D29009" : "#D29009",
    main: !colorMode ? "#FFBA2E" : "#FFBA2E",
    light: !colorMode ? "#F7D973" : "#F7D973",
    lighter: !colorMode ? "#FFF4C6" : "#FFF4C6",
  };
  const orange = {
    darker: !colorMode ? "#823B1D" : "#823B1D",
    dark: !colorMode ? "#DC7125" : "#DC7125",
    main: !colorMode ? "#FF8732" : "#FF8732",
    light: !colorMode ? "#FFC182" : "#FFC182",
    lighter: !colorMode ? "#FFEFD6" : "#FFEFD6",
  };
  const red = {
    darker: !colorMode ? "#7A0916" : "#7A0916",
    dark: !colorMode ? "#B8262D" : "#B8262D",
    main: !colorMode ? "#FF4444" : "#FF4444",
    light: !colorMode ? "#FF9582" : "#FF9582",
    lighter: !colorMode ? "#FFDBD5" : "#FFDBD5",
  };
  const purple = {
    darker: !colorMode ? "#4827A1" : "#5027A1",
    dark: !colorMode ? "#6F37D5" : "#7E37D5",
    main: !colorMode ? "#B661FF" : "#B15FF8",
    light: !colorMode ? "#C684FF" : "#D19BFF",
    lighter: !colorMode ? "#EFD6FF" : "#EFD6FF",
  };
  const pink = {
    darker: !colorMode ? "#770026" : "#770026",
    dark: !colorMode ? "#BE214E" : "#BE214E",
    main: !colorMode ? "#FF3A6C" : "#FF3A6C",
    light: !colorMode ? "#FF87A5" : "#FF87A5",
    lighter: !colorMode ? "#FFC5DA" : "#FFC5DA",
  };
  const grey = {
    darker: !colorMode ? "#242D35" : "#333333",
    dark: !colorMode ? "#323D48" : "#323D48",
    main: !colorMode ? "#555E67" : "#555E67",
    light: !colorMode ? "#8D959D" : "#8D959D",
    lighter: !colorMode ? "#D8D8D8" : "#D8D8D8",
  };

  const palettes = {
    pastel: {
      primary: pink.main,
      secondary: purple.main,
      accent1: yellow.light,
      accent2: pink.light,
      accent3: blue.light,
      accent4: purple.lighter,
      neutral: grey.lighter,
      highlight: yellow.lighter,
    },
    bold: {
      primary: green.main,
      secondary: orange.dark,
      accent1: purple.dark,
      accent2: pink.dark,
      accent3: green.dark,
      accent4: yellow.dark,
      neutral: yellow.darker,
      highlight: grey.dark,
    },
    category: {
      primary: blue.main,
      secondary: orange.main,
      accent1: pink.dark,
      accent2: blue.lighter,
      accent3: green.main,
      accent4: yellow.light,
      neutral: purple.dark,
      highlight: pink.lighter,
      accent5: yellow.darker,
      accent6: grey.light,
    },
    spectral: {
      c1: red.darker,
      c2: red.dark,
      c3: orange.main,
      c4: orange.light,
      c5: yellow.light,
      c6: yellow.lighter,
      c7: green.lighter,
      c8: green.light,
      c9: blue.light,
      c10: blue.main,
      c11: blue.dark,
      c12: blue.darker,
    },
  };

  return {
    green,
    blue,
    yellow,
    orange,
    red,
    purple,
    pink,
    grey,
    pastel: palettes.pastel,
    bold: palettes.bold,
    category: palettes.category,
    spectral: palettes.spectral,
  };
};
